import { useRouter } from 'next/router';
import { useEffect } from 'react';
import settings from '@/settings';

export const useToggleGoogleTopQualityBadge = () => {
  const isUsStore = settings.store === 'reebelo-us';
  const { pathname } = useRouter();

  useEffect(() => {
    if (!isUsStore) {
      return;
    }
    const googleTQBiFrame =
      document.getElementById('merchantverse-iframe') ||
      document.getElementById('merchantverse-iframe-wrapper');

    if (
      pathname === '/collections/[handle]' ||
      pathname === '/products/[handle]'
    ) {
      if (googleTQBiFrame) {
        googleTQBiFrame.style.display = 'block';
      }

      return;
    }

    if (googleTQBiFrame) {
      googleTQBiFrame.style.display = 'none';
    }
  }, [pathname]);
};
